import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LayoutComponent, LayoutSideMenuDirective, LayoutContentDirective } from './layout.component';

@NgModule({
  imports: [CommonModule],
  declarations: [LayoutComponent, LayoutSideMenuDirective, LayoutContentDirective],
  exports: [LayoutComponent, LayoutSideMenuDirective, LayoutContentDirective]
})
export class LayoutModule{}
